import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SnackbarProvider, SnackbarKey, ProviderContext } from 'notistack';
import { CloseIcon } from 'src/client/components/common/SnackBar/CloseIcon';
import { theme } from 'tailwind.config.js';
const { colors } = theme;

type Props = {
  children: React.ReactNode;
};

const useStyles = makeStyles({
  root: {},
  error: {
    background: colors['light-red'],
    width: '50vw',
  },
  success: {
    backgroundColor: colors.green,
  },
  info: {
    background: colors['light-gray5'],
  },
});

export const Snackbar = ({ children }: Props) => {
  const { root, error, success, info } = useStyles();
  const notistackRef = useRef<ProviderContext>(null);

  const handleClickDismiss = (key: SnackbarKey) => {
    if (!notistackRef.current) return;

    notistackRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      hideIconVariant
      classes={{ root, variantError: error, variantSuccess: success, variantInfo: info }}
      ref={notistackRef}
      action={(key) => <CloseIcon onClick={() => handleClickDismiss(key)} />}
    >
      {children}
    </SnackbarProvider>
  );
};
